//Action creator with callback function
export function addUserDetail(userDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_USER_DETAIL',
                payload: userDetails
            });
            resolve(true)
        });
    }
};

export const updateIsTemporaryCart = (isTemporaryCart) => ({
    type: 'UPDATE_IS_TEMPORARY_CART',
    payload: isTemporaryCart
});

export function updateIsFirstLogin(isFirstLogin) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_IS_FIRST_LOGIN',
                payload: isFirstLogin
            });
            resolve(true)
        });
    }
};

export function updateIsNexusFlag(isNexus) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_IS_NEXUS_FLAG',
                payload: isNexus
            });
            resolve(true)
        });
    }
};

export function updateAddress(addressDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_ADDRESS',
                payload: addressDetails
            });
            resolve(true)
        });
    }
};

export function updateRefundOption(refundOptionID) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_REFUND_OPTION',
                payload: refundOptionID
            });
            resolve(true)
        });
    }
};

export const resetUserDetail = () => ({
    type: 'RESET_USER_DETAIL'
});

export function updateIsHasNotificationFlag(userDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_HAS_NOTIFICATION_FLAG',
                payload: userDetails
            });
            resolve(true)
        });
    }
};

export function updateIsCompleteAddress(isComplete) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_ISADDRESSCOMPLETED',
                payload: isComplete
            });
            resolve(true)
        });
    }
};

export function updateIsFirstLoginAfterPremium(isFirstLoginAfterPremium) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_IS_FIRST_LOGIN_AFTER_PREMIUM',
                payload: isFirstLoginAfterPremium
            });
            resolve(true)
        });
    }
};

export function updateAddressDetails(addressDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_ADDRESSDETAILS',
                payload: addressDetails
            });
            resolve(true)
        });
    }
};